<!-- <div class="app-top-search-bar">
<div class="cs-search-outer" aria-label="Search in Chats and Channels">
  <div class="field">
    <p class="control has-icons-left has-icons-right">
      <input type="search" name="globalSearch" id="control-input" class="input" aria-label="Search" placeholder="Search in chats and channels...." [(ngModel)]="search" (keyup)="globalSearchSubject.next($event)">
      <span class="icon is-small is-right">
        <i class="fa fa-search" aria-hidden="true"></i>
      </span>
    </p>
  </div>
</div>
</div> -->

<div class="app-global-search">
  <div class="field">
    <div class="control has-icons-left has-icons-right">
      <input
        type="search"
        name="globalSearch"
        id="control-input"
        class="input"
        aria-label="Search"
        placeholder="Search in chats and channels...."
        [(ngModel)]="search"
        (keyup)="globalSearchSubject.next($event)"
      />
      <span class="icon is-small is-left">
        <i class="fa fa-search"></i>
      </span>
      <!-- <span class="icon is-small is-right">
      <i class="fa fa-times"></i>
    </span> -->
    </div>
    @if (searchBoxFocused && commonSearch && commonSearch.length > 0) {
    <div class="global-search-suggestion">
      <div class="search-suggestion">
        <ul class="suggestion-inner-text" role="list">
          @for (item of commonSearch; track item; let i = $index) {
          <li role="presentation" class="suggestionList">
            <div class="jKWzZXdEJWi__suggestions-inner-container">
              <span class="icon is-small is-left">
                <!-- <i class="fa fa-clock-o"></i> -->
                <i class="fa fa-search"></i>
              </span>
              <div class="sbtc" role="option">
                <div class="sbl1 sbl1p" (click)="getFilterSearchWord(item)">
                  <span>{{ item }}</span>
                </div>
                <div class="sbl2" style="display: none">
                  <span></span>
                </div>
              </div>
              <!-- <div class="sbab">
                <div class="sbai sbdb">Remove</div>
              </div> -->
            </div>
          </li>
          }
        </ul>
      </div>
    </div>
    }
  </div>
</div>
